import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import { css } from "styled-components";

categoryDetailLinkListStyles.subCategoryNameLinkItem = {
    width: 12,
    css: css`
        padding: 10px 15px;
        background: rgb(240, 249, 255);
        border-bottom: 1px solid rgb(210, 219, 234);
        color: rgb(54, 102, 177);
        font-weight: bold;
        font-size: 15px;
    `,
};
